// src/api/accountTypeApi.js
import { accountTypeMockData } from "./mock/accountTypeData";

/**
 * Mendapatkan daftar tipe akun untuk registrasi
 * @returns {Promise<Array>}
 */
export const getAccountTypes = () => {
  return new Promise((resolve) => {
    // Simulasi delay jaringan agar loading state di UI terlihat
    setTimeout(() => {
      resolve(accountTypeMockData);
    }, 500);
  });
};